import * as Sentry from "@sentry/react";
import Block from "@/components/block";
import Button from "@/components/button";
import Container from "@/components/container";
import { Body16, H3 } from "@/components/text";
import { spacings } from "../assets/themes";
import { ID_OFFSET, IS_STAGING } from "./constants";
import polyglot from "./polyglot";

Sentry.init({
  dsn: "https://f5ca8debd006487d8480b904e8d85ba1@sentry.io/1322913",
  environment: IS_STAGING ? "staging" : import.meta.env.MODE,
  release: import.meta.env.VITE_APP_REVISION,
  // prevent send Facebook pixel errors (due to users adblockers)
  ignoreErrors: [/^Can't find variable: fbq$/, /^fbq is not defined$/],
});

if (import.meta.env.VITE_APP_REVISION) {
  Sentry.setTag("release", import.meta.env.VITE_APP_REVISION);
}

const currentUser = (window as any)?.appStore?.current_user;
if (currentUser?.id) {
  Sentry.setUser({
    id: currentUser.id + ID_OFFSET,
  });
}

const ErrorBoundary = ({ children }) => (
  <Sentry.ErrorBoundary
    fallback={() => (
      <>
        <Container.Small>
          <Block margin={spacings.l}>
            <span aria-label="" role="img" style={{ fontSize: "40px" }}>
              🧐
            </span>
            <H3>{polyglot.t("error_boundary.oups")}</H3>
            <Body16>{polyglot.t("error_boundary.description")}</Body16>
            <Block marginTop={spacings.s}>
              <Button.Medium
                onClick={() => {
                  window.location.reload();
                }}
                type="button"
              >
                {polyglot.t("error_boundary.retry")}
              </Button.Medium>
            </Block>
          </Block>
        </Container.Small>
      </>
    )}
  >
    {children}
  </Sentry.ErrorBoundary>
);

export default ErrorBoundary;
